import React, { useState } from 'react';
import ReactFlagsSelect from 'react-flags-select';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import './styles.scss';

import countries from './countries.json';
import { useOffers } from 'features/offers';
import { useSchool } from 'features/school';

const ExternalLink = styled.div`
  color: ${({ theme }) => theme.colors.gray_600};
  ${({ theme }) => theme.fontTypes.type1}

  a {
    color: ${({ theme }) => theme.colors.primary_400};
    text-decoration: underline;

    &:hover {
      color: ${({ theme }) => theme.colors.primary_200};
    }
  }
`;

const Countries = () => {
  const [changed, setChanged] = useState(false);

  const { schoolUuid } = useSchool();
  const { buyInformation, checkout, setCheckout } = useOffers();
  const { offerIdentifier } = useParams();

  let showSelectedLabel = true;
  let showSecondarySelectedLabel = false;

  if (!changed && checkout?.customerCountry === 'BR') {
    showSelectedLabel = false;
    showSecondarySelectedLabel = true;
  }

  const isMeuPlanoCrypto = schoolUuid === '20b929ad-c773-46e2-93de-991988587835';

  let linkExternalCheckout = '';
  if (isMeuPlanoCrypto) {
    // ANUAL / PRINCIPAL
    if (offerIdentifier === 'h6yfvwqiKW') {
      linkExternalCheckout = 'https://pay.hotmart.com/H72111104C?off=atsd0y0i';
    }

    // ALUNOS
    if (offerIdentifier === 'MOARK6kZgN') {
      linkExternalCheckout = 'https://pay.hotmart.com/H72111104C?off=fh2swxbn';
    }

    // ANUAL / LINK DE RECUPERAÇÃO DE VENDAS
    if (offerIdentifier === 'AO8Z02tuVv') {
      linkExternalCheckout = 'https://pay.hotmart.com/H72111104C?off=oi6o4zgz';
    }

    // ALUNOS > LINK DE RECUPERAÇÃO DE VENDAS
    if (offerIdentifier === 'GtMChbn5cK') {
      linkExternalCheckout = 'https://pay.hotmart.com/H72111104C?off=2kor9ofv';
    }
  }

  return !!buyInformation?.creditCardValues?.length ? (
    !!linkExternalCheckout ? (
      <ExternalLink>
        Não mora no Brasil?{' '}
        <a href={linkExternalCheckout} target="_blank" rel="noreferrer">
          Clique aqui
        </a>
        .
      </ExternalLink>
    ) : (
      <ReactFlagsSelect
        customLabels={countries.reduce((prev, country) => {
          return {
            ...prev,
            [country.sigla2]: {
              primary: country.nome,
              secondary: 'Alterar país',
            },
          };
        }, {})}
        searchable
        searchPlaceholder="Procurar"
        showSelectedLabel={showSelectedLabel}
        showSecondarySelectedLabel={showSecondarySelectedLabel}
        showSecondaryOptionLabel={false}
        selectedSize={14}
        optionsSize={14}
        className="payment-countries"
        selectButtonClassName="payment-countries--button"
        selected={checkout?.customerCountry}
        onSelect={(customerCountry) => {
          setChanged(true);
          setCheckout({ customerCountry });
        }}
        placeholder="Alterar país"
        alignOptionsToRight
      />
    )
  ) : (
    <></>
  );
};

export default Countries;
